export function getApiUrl(path) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";
  return `${baseUrl}${path}`;
}

/**
 * Enhanced fetch wrapper that automatically handles token refresh on 401 errors
 */
export const apiFetch = async (url, options = {}) => {
  const fullUrl = url.startsWith('http') ? url : getApiUrl(url);
  
  // Default options with credentials for cookie-based auth
  const defaultOptions = {
    credentials: 'include',
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}), // Only add Content-Type for requests with body
      ...options.headers,
    },
    ...options,
  };

  try {
    // Make the initial request
    let response = await fetch(fullUrl, defaultOptions);

    // If we get a 401 (unauthorized), try to refresh the token
    if (response.status === 401) {
      console.log('🔄 Token expired, attempting refresh...');
      
      // Attempt to refresh the token
      const refreshResponse = await fetch(getApiUrl('/api/auth/refresh'), {
        method: 'POST',
        credentials: 'include',
      });

      if (refreshResponse.ok) {
        console.log('✅ Token refreshed successfully');
        // Retry the original request with the new token
        response = await fetch(fullUrl, defaultOptions);
      } else {
        console.log('❌ Token refresh failed - please log in again');
        // Show user-friendly error instead of redirecting
        throw new Error('Your session has expired. Please refresh the page and log in again.');
      }
    }

    return response;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};
